module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="/comps/create" class="create-league primary-btn hidden-desktop">Create a comp</a>\n<div class="page-header">\n	<form class="league-pin">\n		<h4>Join a Private comp</h4>\n		<input type="text" class="js-league-code" placeholder="Search for a Comp Pin"/>\n		<a href="javascript:void(0)" class="search js-search-league-by-pin ion-ios-search-strong"></a>\n		<a href="javascript:void(0)" class="js-join-league-by-pin secondary-btn">Join</a>\n	</form>\n	<a href="/comps/create" class="create-league primary-btn hidden-mobile">Create a comp</a>\n</div>';
}
return __p;
};
